export const MessageBusEvents = {
  TraverseWorkItemUp: 'traverse-work-item-up',
  TraverseWorkItemDown: 'traverse-work-item-down',
  TraverseWorkItemLeft: 'traverse-work-item-left',
  TraverseWorkItemRight: 'traverse-work-item-right',
  SetDefaultFocusInLane: 'set-default-focus-in-lane',
  SetFocusOnWorkItemLane: 'set-focus-on-work-item-lane',
  SendCannedMessageToEditor: 'send-canned-message-to-editor',
  SendSmartResponseToEditor: 'send-smart-response-to-editor',
  ActivateCannedMessagePanel: 'activate-canned-message-panel',
  ActivateCustomTabPanel: 'activate-custom-tab-panel',
  RequestCustomTabPanel: 'custom-tab-panel-requested',
  CloseCannedMessagePanel: 'close-canned-message-panel',
  ActivateSmartResponsesPanel: 'activate-smart-responses-panel',
  ToggleExpandedMode: 'toggle-expanded-mode',
  ToggleCobrowse: 'toggle-cobrowse',
  ToggleSmartResponses: 'toggle-smart-responses',
  ToggleVisitorInformation: 'toggle-visitor-info',
  ToggleVisitorInformationByWorkItemId: 'toggle-visitor-info-by-work-item-id',
  OpenSettingsMenu: 'open-settings-menu',
  SendWorkItemContent: 'send-work-item-content',
  OpenFileSelect: 'open-file-select',
  TogglePushLinkDialog: 'toggle-push-link',
  ToggleInsertImageDialog: 'toggle-insert-image',
  ChatMessagesQueue: 'chat-messages-queue',
  PendingChatMessages: 'pending-chat-messages',
  ChatMessagesQueueCleared: 'chat-messages-queue-cleared',
  DiscussionStateChanged: 'discussion-state-changed',
  DiscussionMessageInserted: 'discussion-message-inserted',
  WorkItemTransferred: 'work-item-transferred',
  SaveDefaultLaneViewToStorage: 'save-default-lane-view-to-storage',
  FontSizeZoom: 'font-size-zoom',
  AccessibilitySetting: 'accessibility-setting-',
  PreviewInfoPanelVisibility: 'preview-info-panel-visibility',
  PreviewWorkLaneVisibility: 'preview-work-lane-visibility',
  PreviewVisitorHistoryVisibility: 'preview-visitor-history-visibility',
  ShowConfirmationPanelTooltip: 'show-confirmation-panel-tooltip',
  BcAuthLogout: 'bc-auth-logout',
  StreamLoginRequired: 'stream-login-required',
  EmailWorkItemUpdate: 'email-work-item-update',
  WebSocketConnected: 'websocket-connected',
  TakeNext: 'take-next',
  ToggleCannedMessageFolderDropdown: 'toggle-canned-message-folder-dropdown',
  MediaMessage: 'media-message',
  VideoConfirmationVisibilityChanged: 'video-confirmation-visibility-changed',
  VideoAutoStartConfirmationVisibilityChanged: 'video-auto-start-confirmation-visibility-changed',
  VideoWithAcdConfirmationVisibilityChanged: 'video-with-acd-confirmation-visibility-changed',
  CancelRemoteControlSessionConfirmationVisibilityChanged: 'cancel-remote-control-session-confirmation-visibility-changed',
  EnforceStartVideoCall: 'enforce-start-video-call',
  AutoStartVideoCall: 'auto-start-video-call',
  EnforceAutoStartVideoCall: 'enforce-auto-start-video-call',
  IgnoreAutoStartVideoCall: 'ignore-auto-start-video-call',
  CancelStartVideoCall: 'cancel-start-video-call'
};
